import Vue from 'vue';

Vue.component('footer-wrapper-component', {
    data() {
        return {
            agricoleFooterDisclaimer: null,
            isAgricoleFooterDisclaimerVisible: false,
            modelFooterDisclaimer: null,
            hasModelFooterDisclaimer: false,
        };
    },

    mounted() {
        EventBus.$on('agricole-calculator-footer-notes', (notes) => {
            this.agricoleFooterDisclaimer = notes;
            this.isAgricoleFooterDisclaimerVisible = true;
        });

        EventBus.$on('toggle-agricole-calculator-footer-notes', (value) => {
            this.isAgricoleFooterDisclaimerVisible = value;
        });

        // Listen for model footer disclaimer changes
        EventBus.$on(
            'model-footer-disclaimer-changed',
            ({ disclaimer, model }) => {
                this.modelFooterDisclaimer = disclaimer;
                this.hasModelFooterDisclaimer = !!model;
            },
        );

        this.changeRowGap();
    },

    methods: {
        changeRowGap() {
            const footerContainer =
                document.querySelector('.footer-navigation');
            const childCount = footerContainer.childElementCount;

            if (childCount > 4) {
                footerContainer.classList.add('footer-navigation__gap--small');
            }
        },

        // This is from their documentation.
        openCcmConsentModal() {
            CCM.openWidget();
            return false;
        },
    },
});
